import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react';
import { Search, X } from 'lucide-react';
import styles from '../ReportCard.module.scss';

/**
 * Компонент строки поиска с кнопкой «Очистить».
 */
const SearchBar = ({ value, onChange, onClear, placeholder, onKeyDown }) => { useInterfaceLanguage(); return (<div className={styles.searchRow}>
    <div className={styles.searchField}>
      <Search size={18} aria-hidden="true" />
      <input
        type="text"
        aria-label={placeholder || tr("Поиск")}
        placeholder={placeholder || tr("Поиск...")}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        className={styles.queueSearchInput}
      />
    </div>
    {tr(value && (
      <button
        type="button"
        onClick={onClear}
        className={styles.clearSearchButton}
      >
        <X size={16} aria-hidden="true" />{tr("Очистить")}</button>
    ))}
  </div>); };

export default React.memo(SearchBar);
